export default __webpack_public_path__ + "static/blt-2b5c400fb7592d0ffafd8aaf74f2671e.jpg";